module.exports = __webpack_public_path__ + "static/media/stone-specs.844a60b7.png";